/**
 * @desc 회원 정보에서 사용하는 모달 상태 상수 객체
 */
export const userModalStateConst = {
  // 회원 탈퇴
  withDrawal: {
    app: 'withDrawalAPP',
    biling: 'widthDrawalBiling',
    complete: 'withDrawalComplete',
  },
  // 일반 회원 탈퇴
  userWithDrawal: 'userWithDrawal',
  // 사업자 회원 탈퇴
  bizWithdrawal: 'bizWithdrawal',
  // 사업자 회원으로 전환
  bizChange: 'bizChange',
  // ENTERPRISE 상품 전용 - 사업자 회원으로 전환
  bizChangeEnterprise: 'bizChangeEnterprise',
  // 사업자 정보 변경
  bizMailFoam: 'bizMailFoam',
  // 회원가입 성공
  signUpSuccess: 'signUpSuccess',
  initModal: {
    isopen: false,
    modalType: '',
    modalName: '',
  }, // 초기 모달 상태 (열림 여부 및 상태)
};

export const bizWriteStateConst = {
  init: -1, // 초기화
  user: 0, // 기본 회원
  bizWrite: 1, // 사업자 회원 입력 시
  bizModify: 2, // 사업자 회원 정보 수정 시
};

export const userInfoNoDisabledConst = [
  {
    title: '프로필',
    name: 'profile',
  },
  {
    title: '닉네임',
    name: 'nickname',
  },
  {
    title: '연락처',
    name: 'phone',
  },
];

export const userTableConst = [
  {
    title: '이름',
    name: 'name',
  },
  {
    title: '닉네임',
    name: 'nickname',
  },
  {
    title: '연락처',
    name: 'phone',
  },
  {
    title: '회원 유형',
    name: 'role',
  },
  {
    title: '마케팅 동의(선택)',
    name: 'consentReceive',
  },
];

export const userSignUpTableConst = [
  {
    title: '이름',
    name: 'name',
  },
  {
    title: '닉네임',
    name: 'nickname',
  },
  {
    title: '계정',
    name: 'email',
  },
  {
    title: '연락처',
    name: 'phone',
  },
];

export const bizTableConst = [
  {
    title: '계정',
    name: 'email',
  },
  {
    title: '이름',
    name: 'name',
  },
  {
    title: '닉네임',
    name: 'nickname',
  },
  {
    title: '연락처',
    name: 'phone',
  },
];

export const visitRadioConst = [
  { label: '포털(구글, 네이버 등) 검색', type: 'SEARCH' },
  { label: '소셜미디어 채널(링크드인, 페이스북 등)', type: 'SNS' },
  { label: '온라인 광고(검색 광고, 배너 광고 등)', type: 'ADS' },
  { label: 'INAVI Maps 담당자 제안(콜드메일, 박람회 등)', type: 'DIRECT' },
  { label: '기타', type: 'ETC', max: 20, message: '', error: '' },
];
